import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex sm:items-center sm:justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle flex items-center mt-[15px] sm:mt-0" }
const _hoisted_4 = { class: "relative w-[225px] sm:w-[265px] ltr:mr-[10px] rtl:ml-[10px] ltr:sm:mr-[15px] rtl:sm:ml-[15px]" }
const _hoisted_5 = { class: "trezo-card-dropdown relative ltr:-mr-[7px] rtl:-ml-[7px]" }
const _hoisted_6 = {
  class: "trezo-card-content -mx-[20px] md:-mx-[25px]",
  id: "dataTable"
}
const _hoisted_7 = { class: "table-responsive overflow-x-auto" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "text-black dark:text-white" }
const _hoisted_11 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_12 = { class: "flex items-center gap-[10px]" }
const _hoisted_13 = { class: "rounded-full w-[40px]" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "font-medium inline-block mb-px" }
const _hoisted_16 = { class: "block text-gray-500 dark:text-gray-400 text-xs" }
const _hoisted_17 = {
  key: 0,
  class: "text-primary-500 font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036]"
}
const _hoisted_18 = {
  key: 1,
  class: "text-orange-500 font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036]"
}
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_20 = {
  key: 2,
  class: "text-success-700 font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036] ltr:text-right rtl:text-left"
}
const _hoisted_21 = {
  key: 3,
  class: "text-orange-600 font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036] ltr:text-right rtl:text-left"
}
const _hoisted_22 = {
  key: 4,
  class: "text-purple-600 font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036] ltr:text-right rtl:text-left"
}
const _hoisted_23 = { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036] ltr:text-right rtl:text-left" }
const _hoisted_24 = { class: "font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] border-b border-gray-100 dark:border-[#172036] ltr:text-right rtl:text-left" }
const _hoisted_25 = { class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px] sm:flex sm:items-center justify-between" }
const _hoisted_26 = { class: "mb-0 text-sm" }
const _hoisted_27 = { class: "mt-[10px] sm:mt-0" }
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0 font-semibold" }, "Recent Calls")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Search for a name....",
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchQuery]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["trezo-card-dropdown-btn inline-block transition-all text-[22px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500", {
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }]),
            id: "dropdownToggle",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "ri-more-2-fill" }, null, -1)
          ]), 2),
          _cache[6] || (_cache[6] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none\" data-v-6903d7ab><li data-v-6903d7ab><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6903d7ab> This Day </button></li><li data-v-6903d7ab><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6903d7ab> This Week </button></li><li data-v-6903d7ab><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6903d7ab> This Month </button></li><li data-v-6903d7ab><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6903d7ab> This Year </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.key,
                  onClick: ($event: any) => (_ctx.sortTable(header.key)),
                  style: {"cursor":"pointer"},
                  class: _normalizeClass([
                  'font-normal border-t border-gray-100 dark:border-[#172036] ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 whitespace-nowrap cursor-pointer relative',
                  header.className,
                ])
                }, [
                  _createTextVNode(_toDisplayString(header.label) + " ", 1),
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ri-expand-up-down-fill text-gray-500 dark:text-gray-400" }, null, -1))
                ], 10, _hoisted_9))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (call) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: call.id
              }, [
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: call.image,
                        class: "inline-block rounded-full",
                        alt: "product-image"
                      }, null, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(call.name), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(call.number), 1)
                    ])
                  ])
                ]),
                (call.type === 'Inbound')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_17, " Inbound "))
                  : _createCommentVNode("", true),
                (call.type === 'Outbound')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, " Outbound "))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_19, _toDisplayString(call.duration), 1),
                (call.status === 'Resolved')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, " Resolved "))
                  : _createCommentVNode("", true),
                (call.status === 'Pending')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_21, " Pending "))
                  : _createCommentVNode("", true),
                (call.status === 'Dropped')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_22, " Dropped "))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_23, _toDisplayString(call.time), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(call.csat), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", {
        id: "noResultsMessage",
        class: "hidden my-[10px] px-[20px] md:px-[25px]"
      }, " No results found. ", -1)),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("p", _hoisted_26, " Showing " + _toDisplayString(_ctx.startItem + 1) + " to " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.filteredCalls.length) + " Results ", 1),
        _createElementVNode("ol", _hoisted_27, [
          _createElementVNode("li", {
            class: _normalizeClass(["inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { disabled: _ctx.currentPage === 1 }])
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("span", { class: "opacity-0" }, " 0 ", -1),
              _createElementVNode("i", { class: "material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2" }, " chevron_left ", -1)
            ]))
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { active: _ctx.currentPage === page }]),
              key: page
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
              }, _toDisplayString(page), 9, _hoisted_28)
            ], 2))
          }), 128)),
          _createElementVNode("li", {
            class: _normalizeClass(["inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { disabled: _ctx.currentPage === _ctx.totalPages }])
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("span", { class: "opacity-0" }, " 0 ", -1),
              _createElementVNode("i", { class: "material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2" }, " chevron_right ", -1)
            ]))
          ], 2)
        ])
      ])
    ])
  ]))
}